import React from "react";
import { TradeReconcilationContainer } from "../../../containers";

const TradeReconcilation = (props) => {
  return <TradeReconcilationContainer {...props} />;
};

export default TradeReconcilation;
